import { FormatNumberOptions } from 'react-intl';

export const BYTE_SIZE_LEVELS: FormatNumberOptions['unit'][] = [
  'byte',
  'kilobyte',
  'megabyte',
  'gigabyte',
  'terabyte',
];
